







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import FileParseFormatGrid from '../components/file-parsing/file-parse-format-grid.vue';

 @Component({
  components: {
    PageTitle,
    FileParseFormatGrid
  }
})
export default class FileParseFormat extends Vue{}
